export default __webpack_public_path__ + "static/media/astro-scene_3.6c23ad94.png";